import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Bar, Progress, PercentageContainer, Percentage, OpponentPercentage, Labels, Label } from './ProgressChart.style'
import { defaultSize, sizes } from './ProgressChart.sizes'

class ProgressChart extends PureComponent {
    static propTypes = {
        delay: PropTypes.number,
        labels: PropTypes.arrayOf(PropTypes.string),
        size: PropTypes.oneOf(sizes),
        value: PropTypes.number,
        withOpponent: PropTypes.bool,
        withPercentage: PropTypes.bool,
    }

    static defaultProps = {
        delay: 500,
        labels: null,
        size: defaultSize,
        value: 0,
        withOpponent: false,
        withPercentage: false,
    }

    state = {
        isReady: false,
    }

    componentDidMount() {
        const { delay } = this.props
        this.timeout = setTimeout(() => this.setState({ isReady: true }), delay)
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    get percentage() {
        const { value } = this.props
        const rounded = (value * 100).toFixed(0)
        return `${rounded}%`
    }

    get opponentPercentage() {
        const { value } = this.props
        const rounded = ((1 - value) * 100).toFixed(0)
        return `${rounded}%`
    }

    get value() {
        const { value } = this.props

        if (value < 0) {
            return 0
        }

        if (value > 1) {
            return 1
        }

        return value
    }

    render() {
        const { labels, size, withOpponent, withPercentage } = this.props
        const { isReady } = this.state

        return (
            <Wrapper>
                {labels && (
                    <Labels>
                        {labels.length === 1 ? (
                            <Label>{labels[0]}</Label>
                        ) : (
                            <Fragment>
                                <Label>{labels[0]}</Label>
                                <Label>{labels[1]}</Label>
                            </Fragment>
                        )}
                    </Labels>
                )}
                <Bar size={size}>
                    <Progress value={isReady ? this.value : 0} />
                    <PercentageContainer>
                        {withPercentage && <Percentage>{this.percentage}</Percentage>}
                        {withOpponent && <OpponentPercentage>{this.opponentPercentage}</OpponentPercentage>}
                    </PercentageContainer>
                </Bar>
            </Wrapper>
        )
    }
}

export default ProgressChart
